var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { AnchorFooterLink } from '../../atoms/special/AnchorFooterLink/remAnchorFooterLink';
import theme from '../../theme';
export var FooterLink = styled(AnchorFooterLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  :active,\n  :hover {\n    color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n  :active,\n  :hover {\n    color: ", ";\n  }\n"])), theme.primaryColours.aubergine.main, theme.tints.aubergine, theme.primaryColours.white.main);
var templateObject_1;
